// extracted by mini-css-extract-plugin
export default {"breadcrumb__text":"styles_breadcrumb__text__--p3c"};